@if (navegacao.mobile() && navegacao.drawerAberto()) {
  <div class="fixed inset-[0] top-16 z-20 bg-black/40" aria-hidden="true" (click)="navegacao.fecharDrawer()"></div>
}

<nav aria-label="Navegação principal" [class]="classesNav()">
  <div [class]="classesRotuloSecao()">MENU</div>

  @for (item of navegacao.menu(); track item.rotulo; let i = $index) {
    @if (item.submenu) {
      <button
        type="button"
        [class]="classesGrupo()"
        [attr.title]="recolhida() ? item.rotulo : null"
        [attr.aria-expanded]="aberto(item)"
        [attr.aria-controls]="idGrupo(i)"
        (click)="alternarGrupo(item)"
      >
        <app-icon [nome]="item.icone" tamanho="md" class="shrink-0 text-rfy-primary" />
        <span [class]="classesRotulo(aberto(item) || grupoAtivo(item))">{{ item.rotulo }}</span>
        <app-icon
          [nome]="aberto(item) ? 'chevron-baixo' : 'chevron-direita'"
          tamanho="xs"
          [class]="classesChevron(aberto(item))"
        />
      </button>

      <div [attr.id]="idGrupo(i)">
        @if (aberto(item)) {
          <div
            role="group"
            [attr.aria-label]="item.rotulo"
            class="mb-[0.375rem] ml-[1.25rem] flex flex-col gap-0.5 pl-[0.75rem] [border-left:1px_solid_var(--rfy-border-strong)]"
          >
            @for (sub of item.submenu; track sub.rota) {
              <a
                [routerLink]="sub.rota"
                [class]="classesSubitem(ativa(sub.rota))"
                [attr.aria-current]="ativa(sub.rota) ? 'page' : null"
              >
                {{ sub.rotulo }}
              </a>
            }
          </div>
        }
      </div>
    } @else {
      <a
        [routerLink]="item.rota"
        [class]="classesItem(ativa(item.rota))"
        [attr.aria-current]="ativa(item.rota) ? 'page' : null"
        [attr.title]="recolhida() ? item.rotulo : null"
      >
        <app-icon [nome]="item.icone" tamanho="md" class="shrink-0 text-rfy-primary" />
        <span [class]="classesRotulo(false)">{{ item.rotulo }}</span>
      </a>
    }
  }

  @if (!navegacao.mobile()) {
    <div class="min-h-6 flex-1" aria-hidden="true"></div>

    <button type="button" [class]="classesRecolher()" (click)="navegacao.alternarSidenav()">
      <app-icon
        [nome]="recolhida() ? 'chevrons-direita' : 'chevrons-esquerda'"
        tamanho="md"
        class="shrink-0"
      />
      @if (recolhida()) {
        <span class="sr-only">Expandir menu</span>
      } @else {
        <span>Recolher menu</span>
      }
    </button>
  }
</nav>
